module.exports = __webpack_public_path__ + "static/img/code-icon1.8b8005b.png";


//////////////////
// WEBPACK FOOTER
// ./static/popup/code-icon1.png
// module id = CHSb
// module chunks = 1